import Api from './Api';

class Branch extends Api {
  createLink(type, shareData) {
    return new Promise((resolve, reject) => {
      const linkData = {
        campaign: 'Beta',
        channel: 'web',
        feature: 'share',
        alias: '',
        data: shareData,
      };
      const { token } = window.$store.getters;
      if (token) {
        const { user } = window.$store.getters;
        if (user && user.uuid) {
          linkData.data.user_uuid = user.uuid;
        }
      }
      if (window.branch) {
        window.branch.link(linkData, (err, link) => {
          if (err) {
            reject(err);
          } else if (link) {
            resolve(link);
          }
        });
      } else {
        reject(new Error('sdk not found'));
      }
    });
  }

  readDeeplink() {
    return new Promise((resolve, reject) => {
      if (window.branch) {
        window.branch.data((err, data) => {
          if (data) {
            resolve(data);
          } else {
            reject(err);
          }
        });
      }
    });
  }
}

export default Branch;



// WEBPACK FOOTER //
// ./app/src/services/Branch.js